import axios from "axios";
import { Base_URL } from "../url";

export const saveCustomerType = async (customerTypeData, userName = "defaultUser") => {
  try {
    // customerTypeData must already be shaped as { OrganisationId, Description }
    const response = await axios.post(
      `${Base_URL}/CustomerType/CreateCustomerType?UserName=${encodeURIComponent(userName)}`,
      {
        OrganisationId: customerTypeData.OrganisationId, // ✅ exact casing
        Description: customerTypeData.Description,       // ✅ exact casing
      }
    );
    console.log("Customer Type Created:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error saving customer type:", error);
    throw error?.response?.data || "Error saving customer type!";
  }
};

export const getAllCustomerTypes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CustomerType/GetAllCustomerTypes`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching customer types!";
  }
};